import React, { useMemo, useState } from "react";
import { Paper, Avatar, Chip, IconButton } from "@mui/material";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import { Container, Row, Col } from "react-bootstrap";
import AddCircleSharpIcon from "@mui/icons-material/AddCircleSharp";
import CircularProgress from "@mui/material/CircularProgress";
import VerifiedIcon from "@mui/icons-material/Verified";
import { useRouter } from "next/router";
import GroupCourse from "../../Components/Group/GroupCourse";
import GroupSetting from "../../Components/Group/GroupSetting";
import JoinGroup from "../../Components/Group/JoinGroup";
import * as constants from "../../Components/constants";
import GroupMember from "../../Components/Group/GroupMember/GroupMember";
import GroupLeft from "../../Components/Group/GroupLeft/GroupLeft";
import CameraAltTwoToneIcon from "@mui/icons-material/CameraAltTwoTone";
import { Toast, ToastContainer } from "react-bootstrap";
import style from "../../styles/groupId.module.css";
import ResearchSummary from "../../Components/Group/ResearchSummary/ResearchSummary";
import ResearchThought from "../../Components/Group/ResearchThought/ResearchThought";
import PostView from "../../Components/Group/PostView/PostView";
import { NextSeo } from "next-seo";
import SignUpModal from "../../Components/ModalContent/SignUpModal/SignUpModal";
import { useMediaQuery } from "@mui/material";
import Link from "next/link";
const BASE_URL = constants.BASE_URL;
import NodeCache from "node-cache";
const cache = new NodeCache({ stdTTL: 60 * 60 });

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div>{children}</div>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const Profile = ({ isLoggedIn, data, adsId }) => {
  const { group } = data;

  const [coverLoad, setCoverLoad] = useState(false);
  const [value, setValue] = React.useState(0);
  const [groupOwner, setGroupOwner] = useState({});

  const [open, setOpen] = React.useState(false);
  const handleClose = () => setOpen(false);

  //Post Count here start
  const [summary, setSummary] = React.useState([]);
  const [thought, setThought] = React.useState([]);

  //Course Cout here
  const [totalCourse, setTotalCourse] = React.useState("");

  //profile and cover modal
  const [show, setShow] = useState(false);
  const [cover, setCover] = useState(false);

  const [groupCoverPic, setGroupCoverPic] = useState();
  const [groupProfilePic, setGroupProfilePic] = useState();

  //First upload
  const [groupPicture, setGroupPicture] = useState("");
  const [covPicture, setCovPicture] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const router = useRouter();
  const groupID = router.query.groupID;

  //sign up modal
  const [openSingUp, setOpenSignUp] = React.useState(false);
  const handleSignUpClose = () => {
    setOpenSignUp(false);
  };

  const handleSignUpOpen = () => {
    setOpenSignUp(true);
  };

  //Post Count here start

  React.useEffect(() => {
    fetch(`${BASE_URL}/group/${groupID}/details/`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        data.sort((a, b) => {
          return new Date(b.created_date) - new Date(a.created_date);
        });
        setSummary(data.filter((info) => info.title_of_research_article));
        setThought(data.filter((info) => info.description));
      });
  }, [groupID]);

  //Course Count here
  React.useEffect(() => {
    fetch(`${BASE_URL}/course/${groupID}/all/?search=`)
      .then((res) => res.json())
      .then((data) => {
        setTotalCourse(data);
      });
  }, [groupID]);

  //Getting Group Creator Information

  React.useEffect(() => {
    fetch(
      `${BASE_URL}/group/${groupID}/${localStorage.getItem(
        "id"
      )}/member-detail/`,
      {
        method: "GET",
        headers: {
          Authorization: `Token ${localStorage.getItem("auth_token")}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((data) => {
        setGroupOwner(data);
      });
  }, [groupID]);

  //---update Group Profile Photo

  const updateGroupProfilePic = () => {
    const newData = new FormData();
    newData.append("profile_pic", groupProfilePic);

    fetch(`${BASE_URL}/group/${groupID}/group-update/`, {
      method: "PATCH",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
      },
      body: newData,
    })
      .then((res) => {
        setShow(false);
        if (res.status === 200) {
          alert("update profile");
        }
      })

      .catch((error) => console.log(error));
  };

  //---update group cover pic

  const updateGroupCoverPic = () => {
    setCoverLoad(true);
    const newData = new FormData();
    newData.append("cover_pic", groupCoverPic);
    fetch(`${BASE_URL}/group/${groupID}/group-update/`, {
      method: "PATCH",
      headers: {
        Authorization: `Token ${localStorage.getItem("auth_token")}`,
      },
      body: newData,
    })
      .then((res) => {
        if (res.status === 200) {
          setTimeout(() => {
            setCoverLoad(false);
            setCover(false);
          }, 8000);
        }
      })

      .catch((error) => console.log(error));
  };

  const showProfile = (e) => {
    const [file] = e.target.files;

    if (file) {
      setGroupPicture(URL.createObjectURL(file));
    }
  };

  const showCoverImg = (e) => {
    const [file] = e.target.files;
    if (file) {
      setCovPicture(URL.createObjectURL(file));
    }
  };

  setTimeout(() => {
    handleSignUpOpen();
  }, 40000);

  const matches = useMediaQuery("(max-width:768px)");

  const rowClassName = useMemo(() => {
    if (isLoggedIn) {
      return "justify-content-center pt-5 mt-2";
    } else {
      return `${style.main_box} justify-content-center`;
    }
  }, [isLoggedIn]);

  return (
    <Container fluid>
      <NextSeo
        title={`${group.name}`}
        description={`${group.about}`}
        canonical={`https://www.researchrider.com/group/${group.id}`}
        openGraph={{
          url: `https://www.researchrider.com/group/${group.id}`,
          title: `${group.name}`,
          description: `${group.about}`,
          siteName: "www.researchrider.com",
          images: [
            {
              url: `${group.profile_pic}`,
              width: 800,
              height: 600,
              alt: `${group.name}`,
            },
          ],
        }}
      />

      <Row className={rowClassName}>
        <Col xs={0} sm={0} md={0} xl={3} className={style.tab_view}>
          <GroupLeft
            singleGroup={group}
            isLoggedIn={isLoggedIn}
            groupOwner={groupOwner.role}
          />
        </Col>
        <Col xs={12} sm={12} md={12} xl={9}>
          <Paper className="text-center rounded-3 p-2">
            <div className="d-flex justify-content-center">
              <div className={style.cov_content}>
                <Avatar
                  className="border rounded-3"
                  sx={{
                    objectFit: "cover",
                    width: "100%",
                    height: "250px",
                  }}
                  src={covPicture ? covPicture : group.cover_pic}
                  alt={group.name}
                />
                {groupOwner.role == "Creator" && (
                  <IconButton
                    className={`${style.cov_upload}`}
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                  >
                    <CameraAltTwoToneIcon onClick={() => setCover(true)} />
                  </IconButton>
                )}
              </div>
            </div>

            <Col className="d-flex align-items-center justify-content-between">
              <div className="d-flex  align-items-center mx-4 flex-wrap">
                <div className={`${style.wrapper}`}>
                  <div className={style.content}>
                    <Avatar
                      style={{
                        border: "1px solid gray",
                        marginTop: "-30px",
                        objectFit: "cover",
                        width: "100px",
                        height: "100px",
                      }}
                      alt={group.name}
                      src={groupPicture ? groupPicture : group.profile_pic}
                    />
                    {groupOwner.role == "Creator" && (
                      <IconButton
                        className={`${style.upload}`}
                        color="primary"
                        aria-label="upload picture"
                        component="label"
                      >
                        <CameraAltTwoToneIcon onClick={() => setShow(true)} />
                      </IconButton>
                    )}
                  </div>
                </div>
                <b className="mx-2 mb-3">
                  {group.name ? group.name : "Group Name"}{" "}
                  {group.is_verified && (
                    <VerifiedIcon color="primary" sx={{ fontSize: "20px" }} />
                  )}
                </b>
              </div>
              {groupOwner.role == "Creator" && (
                <div>
                  <Chip
                    onClick={() => setOpen(true)}
                    label="Join"
                    variant="outlined"
                    color="primary"
                    className="m-2"
                    icon={<AddCircleSharpIcon />}
                  />
                </div>
              )}
            </Col>

            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              aria-label="basic tabs example"
            >
              <Tab label={<b>Home</b>} />
              <Tab
                label={
                  <b>
                    Research Thought{" "}
                    <span className="text-primary">({thought?.length})</span>
                  </b>
                }
              />
              <Tab
                label={
                  <b>
                    Research Summary{" "}
                    <span className="text-primary">({summary?.length})</span>
                  </b>
                }
              />
              <Tab
                label={
                  <b>
                    Group Course{" "}
                    <span className="text-primary">
                      ({totalCourse?.length})
                    </span>
                  </b>
                }
              />
              <Tab label={<b>People</b>} />
              <Tab label={<b>About</b>} />
              {matches && groupOwner.role == "Creator" && (
                <Tab
                  label={
                    <b>
                      <Link href={`/group/wallet/${group.id}`}>
                        <a target="_blank">Wallet</a>
                      </Link>
                    </b>
                  }
                />
              )}
            </Tabs>
          </Paper>
          <div>
            <TabPanel value={value} index={0}>
              <PostView
                isLoggedIn={isLoggedIn}
                groupID={groupID}
                singleGroup={group}
                groupOwner={groupOwner}
                adsId={adsId}
              />
            </TabPanel>
            <TabPanel value={value} index={1}>
              <ResearchThought
                groupID={groupID}
                isLoggedIn={isLoggedIn}
                adsId={adsId}
              />
            </TabPanel>
            <TabPanel value={value} index={2}>
              <ResearchSummary
                groupID={groupID}
                isLoggedIn={isLoggedIn}
                adsId={adsId}
              />
            </TabPanel>

            <TabPanel value={value} index={3}>
              <GroupCourse groupID={groupID} />
            </TabPanel>

            <TabPanel value={value} index={4}>
              <GroupMember groupID={groupID} isLoggedIn={isLoggedIn} />
            </TabPanel>

            <TabPanel value={value} index={5}>
              <GroupSetting groupID={groupID} role={groupOwner.role} />
            </TabPanel>
            <TabPanel value={value} index={6}>
              <PostView
                isLoggedIn={isLoggedIn}
                groupID={groupID}
                singleGroup={group}
                groupOwner={groupOwner}
                adsId={adsId}
              />
            </TabPanel>
          </div>
        </Col>
      </Row>

      <>
        <JoinGroup
          open={open}
          handleClose={() => handleClose()}
          groupID={groupID}
        />

        {isLoggedIn === false && (
          <SignUpModal
            open={openSingUp}
            handleClose={handleSignUpClose}
            handleOpen={handleSignUpOpen}
          />
        )}

        <ToastContainer position="middle-center" className="px-3">
          <Toast onClose={() => setShow(false)} show={show} delay={3000}>
            <Toast.Header>
              <strong className="me-auto">Change your profile picture</strong>
            </Toast.Header>
            <Toast.Body>
              <input
                onChange={(e) => {
                  setGroupProfilePic(e.target.files[0]);
                  showProfile(e);
                }}
                type="file"
                name="picture"
                accept="image/*"
              />
              <button
                className={style.btn}
                onClick={() => updateGroupProfilePic()}
              >
                upload
              </button>
            </Toast.Body>
          </Toast>
        </ToastContainer>

        <ToastContainer position="middle-end" className="px-3">
          <Toast onClose={() => setCover(false)} show={cover} delay={3000}>
            <Toast.Header>
              <strong className="me-auto">Change your cover picture</strong>
            </Toast.Header>
            <Toast.Body>
              <input
                onChange={(e) => {
                  setGroupCoverPic(e.target.files[0]);
                  showCoverImg(e);
                }}
                type="file"
                name="picture"
                accept="image/*"
              />

              {coverLoad ? (
                <CircularProgress size={20} sx={{ mx: 1 }} />
              ) : (
                <button
                  className={style.btn}
                  onClick={() => updateGroupCoverPic()}
                >
                  upload
                </button>
              )}
            </Toast.Body>
          </Toast>
        </ToastContainer>
      </>
    </Container>
  );
};

export default Profile;

//Getting single course using

export async function getServerSideProps(router) {
  const id = router.query.groupID;

  // Check if data is already in cache
  const cachedData = cache.get(id);
  if (cachedData) {
    return {
      props: {
        data: cachedData,
        id,
      },
    };
  }

  const res = await fetch(
    `https://researchrider.xyz/group/${id}/group-detail/`,
    {
      headers: {
        Accept: "application/json, text/plain, */*",
        "User-Agent": "*",
      },
    }
  );
  const data = await res.json();
  // Cache the data
  cache.set(id, data);

  return {
    props: {
      data,
      id,
    },
  };
}
